<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <ReviewDetails slot-scope="{data}" :form-data="data"></ReviewDetails>
  </l-cache>
</template>
<script>
  import ReviewDetails from './reviewDetails'
  export default {
    name: 'reviewDetailBox',
    components: {ReviewDetails},
    methods: {
      async getItem (key) {
        let {items} = await this.$store.dispatch('school/getApplyList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
    }
  }
</script>
